module.exports = __webpack_public_path__ + "static/media/form.d45be3ce.svg";